import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import '../MfLanding/MfCard.css';

function MfCardNFO() {
    const [data, setData] = useState(false);
    const { BaseLiveURL } = useContext(URLstateContext);
    const [nodatafound, setnodatafound] = useState(false);

    // useEffect(() => {
    //     const getUrl = BaseURL + "MfNewFundOffer";
    //     fetch(`${getUrl}/NFO/-/8`)
    //         .then((response) => response.json())
    //         .then((dataNFO) => {
    //             getDataHoldingFandO = dataNFO.data;
    //             setData(getDataHoldingFandO);
    //             //    console.log(getDataHoldingFandO, "MfDividend")
    //         })
    //         .catch((error) => {
    //         });
    // }, []);

    useEffect(() => {
        postData('/api/Login/MarketBanner', { Caption: "Mutual Fund" })
            .then((data) => {

                if (data.data != null && data.data.length > 0) { setnodatafound(false); setData(data.data); }
                else { setData(null); setnodatafound(true); }
            });
    }, []);

    async function postData(url = '', data = {}) {
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
    }

    const images = data &&
        data.map(image => {
            return (
                <a href={image.bannerUrl} target="_blank">
                    <img key={image.uploadfile} src={BaseLiveURL + "marketimages/" + image.uploadfile} className="img-responsive moreContent" />
                </a>
            )
        });

    return (
        <>
            <div className='market-right-sc Mutual-fund-keysection'>
                    {images}
                {nodatafound &&
                    <p className="textcenter nodata">No Image found !!!</p>
                }
                {/* {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                {(data[0] != undefined) ?
                    <div className='ipo-right-pnl'>
                        <h2>MF Schemes</h2>
                        <label>Scheme Name :</label>
                        <p>{(data[0].Sch_Name != undefined) ? data[0].Sch_Name : ''}</p>
                        <label>Type :</label>
                        <p>Open</p>
                        <label>Launch Date :</label>
                        <p>{(data[0].Launc_Date.split('T')[0] != null) ? data[0].Launc_Date.split('T')[0] : 0}</p>
                        <label>Riskometervalue:</label>
                        <p>{(data[0].riskometervalue != null) ? data[0].riskometervalue : 's'}</p>
                        <div className='market-btn'>
                            <a href="https://ekyc.moneysukh.com:8443/index.aspx" target="_blank">Get Started</a>
                        </div>
                    </div> : ''} */}
            </div>
        </>
    )
}

export default MfCardNFO